<script setup>
defineProps({
  bloccoSovrapposto: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
  dark: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div :class="['overlap-block', type]">
    <div class="container row-80">
      <!-- eslint-disable vue/no-v-html -->
      <template v-if="type === 'type1'">
        <div class="content max">
          <div v-if="bloccoSovrapposto.titoloSinistra" class="left">
            <div class="heading-2" v-html="bloccoSovrapposto.titoloSinistra" />
          </div>
          <div class="right">
            <div
              v-if="bloccoSovrapposto.testoDestra"
              class="text-2"
              v-html="bloccoSovrapposto.testoDestra"
            />
            <div class="section-button">
              <MainButton
                v-if="bloccoSovrapposto.cta.testo && bloccoSovrapposto.cta.link"
                :text="bloccoSovrapposto.cta.testo"
                :url="bloccoSovrapposto.cta.link"
                :internal-link="true"
                :is-black="false"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="type === 'type2'">
        <div class="content max" :class="[{ dark }]">
          <div v-if="bloccoSovrapposto.immagineSinistra" class="left">
            <DefaultPicture
              :image="{
                custom: bloccoSovrapposto.immagineSinistra.responsiveImage,
              }"
              :lazy-load="true"
              :alt="bloccoSovrapposto.testoDestra"
            />
          </div>
          <div class="right">
            <div
              v-if="bloccoSovrapposto.testoDestra"
              class="heading-2"
              v-html="bloccoSovrapposto.testoDestra"
            />
            <div
              v-if="bloccoSovrapposto.secondoTestoDestra"
              class="text-2 secondo-testo"
              v-html="bloccoSovrapposto.secondoTestoDestra"
            />
            <div class="section-button">
              <MainButton
                v-if="
                  bloccoSovrapposto.cta &&
                  bloccoSovrapposto.cta.testo &&
                  bloccoSovrapposto.cta.link
                "
                :text="bloccoSovrapposto.cta.testo"
                :url="bloccoSovrapposto.cta.link"
                :internal-link="true"
                :is-black="false"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OverlapBlock',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
